



import { BaseEntityResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEntitiesResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseDataResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseResponse } from '@m4u-angular/base/entities/BaseEntities';
import { GenericListEntity } from '@m4u-angular/base/entities/BaseEntities';
import { DataGroupInfo } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEndpoint } from '@m4u-angular/base/endpoint/BaseEndpoint';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { APIGatewayService } from '@m4u-angular/core/gateway/APIGateway.service';
import { EnumRequestProgressTracking } from '@m4u-angular/core/framework/sysenums.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomerAddress } from './../entities/customeraddress.entity';
import { Country } from './../entities/country.entity';
import { State } from './../entities/state.entity';
import { CustomerAddressesListParams } from './../params/customeraddresseslist.param';
@Injectable()
export class CustomerAddressEndpoint extends BaseEndpointCRUD<CustomerAddress>
{
    constructor(api: APIGatewayService) {super("CustomerAddress", api);}
	

    public  ListEx(oParams: CustomerAddressesListParams, options: DataLoadOptions) : Observable<BaseEntitiesResponse<CustomerAddress>>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'ListEx', oParams,  options?.GetLoadOptions() );
    }

    public override Get(EntryID: number) : Observable<BaseEntityResponse<CustomerAddress>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'Get',  {EntryID: EntryID} );
    }

    public override Save(Entity: CustomerAddress) : Observable<BaseEntityResponse<CustomerAddress>>
	{
		return this.api.ExecutePostAction(this.ControllerName, 'Save', Entity,  undefined );
    }

    public  GetCountries() : Observable<BaseEntitiesResponse<Country>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetCountries',  undefined );
    }

    public  GetStatesByCountryCode(sCountryCode: string) : Observable<BaseEntitiesResponse<State>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetStatesByCountryCode',  {sCountryCode: sCountryCode} );
    }
}

